import type { AppFeatureDefinition } from "@nasam/kernel";
import { createAnalyticsAndInsightsRoutes } from "./presentation/routes";

// Irregular: submodule and screen share the same segment name ("dashboard"),
// and the backend only ever grants view.
const DASHBOARD_VIEW = "analytics_and_insights.dashboard.dashboard.view";

export const analyticsAndInsightsFeature: AppFeatureDefinition = {
  id: "analytics-and-insights",
  version: "0.1.0",
  titleKey: "common:businessModules.analyticsAndInsights",
  icon: "LayoutDashboard",
  basePath: "/analytics",
  requiredPermissions: [DASHBOARD_VIEW],
  navigation: [
    {
      id: "analytics-and-insights",
      titleKey: "common:businessModules.analyticsAndInsights",
      icon: "LayoutDashboard",
      placement: "rail",
      order: 70,
      // TEMP: the dashboard screen isn't built yet -- hide the rail tab
      // client-side until it is, then drop this line. Permission gating
      // (requiredPermissions above/below) is untouched.
      hidden: true,
      children: [
        {
          id: "analytics-dashboard",
          titleKey: "analyticsAndInsights:nav.dashboard",
          placement: "drawer",
          order: 10,
          path: "/analytics/dashboard",
          requiredPermissions: [DASHBOARD_VIEW],
        },
      ],
    },
  ],
  routes: (context) => createAnalyticsAndInsightsRoutes({ context }),
  i18n: {
    namespace: "analyticsAndInsights",
    load: {
      en: () => import("./i18n/en"),
      ar: () => import("./i18n/ar"),
    },
  },
  permissionCatalog: [
    {
      segment: "analytics_and_insights",
      labelKey: "analyticsAndInsights:permissions.analyticsAndInsights",
      children: [
        {
          segment: "dashboard",
          labelKey: "analyticsAndInsights:permissions.dashboard",
          children: [
            {
              segment: "dashboard",
              labelKey: "analyticsAndInsights:permissions.dashboard",
              actions: [
                {
                  id: "view",
                  labelKey: "analyticsAndInsights:actions.view",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
